// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2Kood","Container":"App_Container__3kU0d","Footer":"App_Footer__g559g","Extern":"App_Extern__FJYHp"};